import { SxProps, Theme } from "@/common/styles/style";
import { CSSProperties } from "react";

export const modifyStyle: CSSProperties = {
  width: "95%",
  margin: "0 auto",
  marginBottom: "80px",
};

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    width: "100%",
  },
  subContainer: {
    width: "95%",
    margin: "0 auto",
  },
  titleArea: { margin: "2rem 0" },
  title: {
    fontSize: 30,
  },
  card: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    margin: "0.5rem 0",
    padding: "1rem",
  },
  cardHeaderTitle: {
    ".MuiCardHeader-title": {
      fontSize: 20,
    },
  },
  bottom: {
    width: "94%",
    height: "70px",
    position: "fixed",
    left: 0,
    bottom: 0,
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "6%",
    alignItems: "center",
  },
};
